import React from 'react';
import { BatteryFullIcon, LockIcon, SignalIcon, WifiIcon } from 'lucide-react';
export function DeviceFrame({
  device,
  children
}: {
  device: 'mobile' | 'desktop';
  children: React.ReactNode;
}) {
  if (device === 'mobile') {
    return <div className="h-[min(820px,calc(100vh-150px))] min-h-[600px] w-[390px] shrink-0 rounded-[48px] bg-black p-[10px] shadow-2xl" data-id="element-285" data-mp="24bsl3wcd5sny">
        <div className="flex h-full flex-col overflow-hidden rounded-[38px] bg-white" data-id="element-286" data-mp="1uf5zv6g4kzle">
          <div className="flex h-11 shrink-0 items-center justify-between px-7 text-[15px] font-semibold text-black" aria-hidden="true" data-id="element-287" data-mp="1uh0mqqayj1s4">
            <span data-id="element-288" data-mp="1lm2qb98lp6w1">9:41</span>
            <span className="flex items-center gap-1" data-id="element-289" data-mp="1lndrd1anw0jg">
              <SignalIcon className="h-4 w-4" data-id="element-290" data-mp="1goayef7yhkru" />
              <WifiIcon className="h-4 w-4" data-id="element-291" data-mp="1gpc7ie5evx6x" />
              <BatteryFullIcon className="h-5 w-5" data-id="element-292" data-mp="1boesubjm1la6" />
            </span>
          </div>
          <div className="min-h-0 flex-1" data-id="element-293" data-mp="16ple6fsl7o8f">{children}</div>
        </div>
      </div>;
  }
  return <div className="flex h-[calc(100vh-150px)] min-h-[620px] w-full max-w-[1280px] flex-col overflow-hidden rounded-xl border border-proto-line bg-white shadow-xl" data-id="element-294" data-mp="38cdy94ev54qs">
      <div className="flex h-10 shrink-0 items-center gap-3 border-b border-proto-line bg-proto-hover px-4" aria-hidden="true" data-id="element-295" data-mp="3d4f52at9i39f">
        <span className="flex gap-1.5" data-id="element-296" data-mp="33dar9efboog6">
          <span className="h-3 w-3 rounded-full bg-[#ff5f57]" data-id="element-297" data-mp="33ecd8dxvmvco" />
          <span className="h-3 w-3 rounded-full bg-[#febc2e]" data-id="element-298" data-mp="3r352jrjzu4yb" />
          <span className="h-3 w-3 rounded-full bg-[#28c840]" data-id="element-299" data-mp="3r3n5t852pjfq" />
        </span>
        <span className="mx-auto flex items-center gap-1.5 rounded-md bg-white px-4 py-1 font-proto text-xs text-proto-muted" data-id="element-300" data-mp="3w0nfru51n6c4">
          <LockIcon className="h-3 w-3" data-id="element-301" data-mp="3h6sbl1fu2579" />
          register.i9sports.com/north-tampa/spring-2027-flag-football
        </span>
      </div>
      <div className="min-h-0 flex-1" data-id="element-302" data-mp="25p0zrtd5xj3b">{children}</div>
    </div>;
}